import { render, staticRenderFns } from "./ClSwitch.html?vue&type=template&id=6b86b5b0&"
import script from "./ClSwitch.ts?vue&type=script&lang=ts&"
export * from "./ClSwitch.ts?vue&type=script&lang=ts&"
import style0 from "./ClSwitch.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports